import { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FirebaseAuthenticationClient } from '@framework/firebase/auth';
import { FirebaseAnalyticsOperation } from '@framework/firebase/analytics';
import { trpcClient } from '@framework/trpcClient';
import { useTranslation } from 'react-i18next';

export const LogoutPage: React.FC<unknown> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // RTDB上に永続化された認証セッション情報を無効化した後に、Firebase Authentication のサインアウト処理を行う。
    trpcClient.user.auth.signOut
      .mutate()
      .then(() => {
        return FirebaseAuthenticationClient.signOut();
      })
      .then(() => {
        return FirebaseAnalyticsOperation.logEvent('logout');
      })
      .then(() => {
        // Firebase Authentication の signOut による認証状態更新が完了するのを待つために、
        // 画面遷移は次の tick で実行する
        setTimeout(() => navigate(searchParams.get('requestPath') || '/'), 0);
      });
  }, [navigate, searchParams]);

  return (
    <div className="fixed left-0 top-0 z-50 flex h-screen w-screen flex-col items-center justify-center">
      <FontAwesomeIcon icon={faSpinner} className="fa-spin text-4xl text-brand" />
      <div className="pt-4 text-center text-2xl font-bold text-brand">{t('auth.logout.loading')}</div>
      <Link to="/" className="pt-8 text-xl text-blue-500 hover:text-blue-900 hover:underline">
        {t('auth.backToHome.label')}
      </Link>
    </div>
  );
};
